import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="main-footer">
        <strong>
          Copyright © 2001-2023 <a href="http://www.infarma.com.br">Infarma Sistemas</a>.
        </strong>
        Todos os direitos reservados.
        <div className="float-right d-none d-sm-inline-block">
          <b>Versão</b> 1.0.0
        </div>
      </footer>
    </div>
  );
}
